import { SpinnerAppearance as FluentSpinnerAppearance, SpinnerSize as FluentSpinnerSize } from "@fluentui/web-components";
/** Appearance values for {@link Spinner}. */
export const SpinnerAppearances = { ...FluentSpinnerAppearance };
/** Size values for {@link Spinner}. */
export const SpinnerSizes = { ...FluentSpinnerSize };
//# sourceMappingURL=spinner.options.js.map